import ProductList from './ProductList';

export default (props) => {
  return <ProductList {...props} />;
};
